import { graphql } from 'relay-runtime';

export const EDIT_PROFILE_FORM_QUERY = graphql`
  query EditProfileFormQuery($username: String, $internalId: String) {
    me {
      user {
        ... on AtlassianAccountUser {
          ...AtlassianAccountUserFragment
        }
      }
    }
    unified {
      unifiedProfile(
        unifiedProfileUsername: $username
        internalId: $internalId
      ) {
        ... on UnifiedProfile {
          ...UnifiedProfileFragment
        }
        ... on UnifiedQueryError {
          identifier
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
      atlassianProducts {
        ... on UnifiedAtlassianProductConnection {
          ...AtlassianProductsFragment
        }
      }
    }
  }
`;
